/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Preview_MiddleInputs */

const en_highlight_settings_preview_middle = /** @type {(inputs: Highlight_Settings_Preview_MiddleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`preview showing how the`)
};

const es_highlight_settings_preview_middle = /** @type {(inputs: Highlight_Settings_Preview_MiddleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`previa de cómo se ve la palabra`)
};

/**
* | output |
* | --- |
* | "preview showing how the" |
*
* @param {Highlight_Settings_Preview_MiddleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_preview_middle = /** @type {((inputs?: Highlight_Settings_Preview_MiddleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Preview_MiddleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_preview_middle(inputs)
	return en_highlight_settings_preview_middle(inputs)
});